/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_No_Low_StockInputs */

const vi_warehouse_sales_no_low_stock = /** @type {(inputs: Warehouse_Sales_No_Low_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có sản phẩm sắp hết.`)
};

/**

* @param {Warehouse_Sales_No_Low_StockInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_no_low_stock = /** @type {((inputs?: Warehouse_Sales_No_Low_StockInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_No_Low_StockInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_no_low_stock(inputs)
});